"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryOrder = void 0;
const business_types_1 = require("@deliverr/business-types");
class InventoryOrder {
    constructor({ orderRef, lineItemDetails, shipmentId, warehouseId, shipmentCancellationReason, shipmentError, orderType, poolName, shipmentCreatedBy, }) {
        this.orderRef = orderRef;
        this.poolName = poolName || business_types_1.InventoryPool.DEFAULT;
        this.shipmentCreatedBy = shipmentCreatedBy;
        this.orderType = orderType;
        this.notes = null;
        this.shipmentId = shipmentId;
        this.warehouseId = warehouseId;
        this.lineItems = lineItemDetails.map((x) => ({
            dsku: x.dsku,
            numberOfUnits: x.qty,
            orderLineItemRef: `${orderRef}.${x.dsku}`,
            lotNumber: x.lotNumber,
            expirationDate: x.expirationDate,
        }));
        this.shipmentCancellationReason = shipmentCancellationReason;
        this.shipmentError = shipmentError;
    }
}
exports.InventoryOrder = InventoryOrder;
//# sourceMappingURL=InventoryOrder.js.map